import { RootState } from 'store/root-reducer';

export const educationalInstituteSummarySelector = ({ educationInstitute }: RootState) =>
  educationInstitute.summary;

export const educationalInstituteOptionSelector = ({ educationInstitute }: RootState) =>
  educationInstitute.options;
